// Move data and function definitions outside of DOMContentLoaded

const defaultBookingLink =
  "https://outlook.office.com/book/BeratungsterminmiteinemconcileMitarbeiter@concile.de/?ismsaljsauthenabled";

const contacts = {
  AR: { short: "AR", name: "Angela Reiß", bookingLink: defaultBookingLink },
  CF: { short: "CF", name: "Christin Fossberg", bookingLink: defaultBookingLink },
  JCF: { short: "JCF", name: "Jean-Claude Fourcade", bookingLink: defaultBookingLink },
  ST: { short: "ST", name: "Sylvia Türr", bookingLink: defaultBookingLink },
  UK: { short: "UK", name: "Ulrich Köhler", bookingLink: defaultBookingLink },
  CB: { short: "CB", name: "Christoph Becker", bookingLink: defaultBookingLink },
  KR: { short: "KR", name: "Karin Rolle", bookingLink: defaultBookingLink },
  AGB: { short: "AGB", name: "Alexander Goczok-Bauer", bookingLink: defaultBookingLink },
  AN: { short: "AN", name: "Angelique Neumann", bookingLink: defaultBookingLink },
  SF: { short: "SF", name: "Susanne Fritz", bookingLink: defaultBookingLink },
  GM: { short: "GM", name: "Grit Maetzig", bookingLink: defaultBookingLink },
  SW: { short: "SW", name: "Susann Wittchen", bookingLink: defaultBookingLink },
  DH: { short: "DH", name: "Doris Heitmann", bookingLink: defaultBookingLink }
};

// Sonderbereiche überschreiben die 2-stellige Zuordnung
const specialRanges = [
  { start: 16899, end: 16999, contact: contacts.AR },

  { start: 21300, end: 21399, contact: contacts.AR },
  { start: 22900, end: 22999, contact: contacts.AR },

  { start: 23879, end: 23879, contact: contacts.ST },
  { start: 23909, end: 23909, contact: contacts.ST },
  { start: 24534, end: 24539, contact: contacts.ST },

  { start: 29000, end: 29399, contact: contacts.SW },
  { start: 29400, end: 29699, contact: contacts.AR },

  { start: 37000, end: 37599, contact: contacts.SW },

  { start: 63000, end: 63799, contact: contacts.KR },
  { start: 63800, end: 63999, contact: contacts.SF },

  { start: 69001, end: 69151, contact: contacts.KR },
  { start: 69152, end: 69190, contact: contacts.CB },
  { start: 69191, end: 69999, contact: contacts.KR },

  { start: 72600, end: 72699, contact: contacts.CB },
  { start: 76400, end: 76599, contact: contacts.CB },

  { start: 80000, end: 80599, contact: contacts.AN },
  { start: 80600, end: 80699, contact: contacts.AGB },
  { start: 80700, end: 80899, contact: contacts.AN },
  { start: 80900, end: 81499, contact: contacts.AGB },
  { start: 81500, end: 82099, contact: contacts.AN },

  { start: 85000, end: 85199, contact: contacts.SF },
  { start: 85200, end: 85999, contact: contacts.AN },

  { start: 88100, end: 88199, contact: contacts.AGB },
  { start: 88299, end: 88299, contact: contacts.AGB },
  { start: 88300, end: 88499, contact: contacts.AGB },

  { start: 94234, end: 94234, contact: contacts.SF }
];

const plzMapping = {
  "01": contacts.GM,
  "02": contacts.GM,
  "03": contacts.CF,
  "04": contacts.GM,
  "06": contacts.GM,
  "07": contacts.GM,
  "08": contacts.GM,
  "09": contacts.GM,

  "10": contacts.CF,
  "11": contacts.CF,
  "12": contacts.CF,
  "13": contacts.CF,
  "14": contacts.CF,
  "15": contacts.CF,
  "16": contacts.CF,

  "17": contacts.AR,
  "18": contacts.AR,
  "19": contacts.AR,

  "20": contacts.DH,
  "21": contacts.DH,
  "22": contacts.DH,

  "23": contacts.AR,

  "24": contacts.DH,
  "25": contacts.DH,

  "26": contacts.UK,
  "27": contacts.DH,
  "28": contacts.DH,

  "30": contacts.SW,
  "31": contacts.SW,

  "32": contacts.UK,
  "33": contacts.UK,

  "34": contacts.KR,
  "35": contacts.KR,
  "36": contacts.KR,

  "37": contacts.SW,
  "38": contacts.SW,
  "39": contacts.SW,

  "40": contacts.ST,
  "41": contacts.ST,

  "42": contacts.UK,
  "44": contacts.UK,
  "45": contacts.UK,
  "46": contacts.UK,
  "47": contacts.UK,
  "48": contacts.UK,
  "49": contacts.UK,

  "50": contacts.ST,
  "51": contacts.ST,
  "52": contacts.ST,
  "53": contacts.ST,
  "54": contacts.ST,

  "55": contacts.KR,
  "56": contacts.ST,
  "57": contacts.KR,

  "58": contacts.UK,
  "59": contacts.UK,

  "60": contacts.KR,
  "61": contacts.KR,
  "64": contacts.KR,
  "65": contacts.KR,

  "66": contacts.JCF,

  "67": contacts.KR,
  "68": contacts.KR,

  "70": contacts.CB,
  "71": contacts.CB,
  "72": contacts.CB,
  "73": contacts.CB,
  "74": contacts.CB,
  "75": contacts.CB,
  "76": contacts.CB,
  "77": contacts.CB,
  "78": contacts.CB,
  "79": contacts.CB,

  "82": contacts.AGB,
  "83": contacts.AN,
  "84": contacts.AN,
  "85": contacts.AN,
  "86": contacts.AGB,
  "87": contacts.AGB,
  "88": contacts.CB,
  "89": contacts.AGB,

  "90": contacts.SF,
  "91": contacts.SF,
  "92": contacts.SF,
  "93": contacts.SF,
  "94": contacts.SF,
  "95": contacts.SF,
  "96": contacts.SF,
  "97": contacts.SF,
  "98": contacts.SF,

  "99": contacts.GM
};

function getContactByPlz(plzInput) {
  if (plzInput.length !== 5 || isNaN(parseInt(plzInput, 10))) return null;

  const plzNumber = parseInt(plzInput, 10);

  for (const range of specialRanges) {
    if (plzNumber >= range.start && plzNumber <= range.end) {
      return range.contact;
    }
  }

  const prefix = plzInput.substring(0, 2);
  return plzMapping[prefix] || null;
}

document.addEventListener('DOMContentLoaded', function () {
  // Original findContact function for main PLZ finder
  window.findContact = function () {
    const plzInput = document.getElementById('plz').value;
    const resultDiv = document.getElementById('result');

    resultDiv.style.display = 'none';

    if (plzInput.length < 5) {
      alert('Bitte geben Sie eine vollständige, 5-stellige Postleitzahl ein');
      return;
    }

    const contact = getContactByPlz(plzInput);

    setTimeout(() => {
      resultDiv.style.display = 'block';
      if (contact) {
        resultDiv.innerHTML = `
          <div class="result-header">Ihr Ansprechpartner</div>
          <div class="result-content">
            <p>Für die PLZ ${plzInput} ist ${contact.name} zuständig.</p>
            <a href="${contact.bookingLink}" class="booking-hint" target="_blank">
              Jetzt Beratungstermin vereinbaren →
            </a>
          </div>`;
      } else {
        resultDiv.innerHTML = `<div class="result-content"><p>Für die PLZ ${plzInput} wurde leider kein Ansprechpartner gefunden.</p></div>`;
      }
    }, 100);
  };

  // Input validation for main PLZ finder
  const plzInput = document.getElementById('plz');
  if (plzInput) {
    plzInput.addEventListener('input', function (e) {
      this.value = this.value.replace(/[^0-9]/g, '').substring(0, 5);
    });
  }

  // Event delegation for submit button
  document.addEventListener('click', function (e) {
    const target = e.target;
    if (target && target.closest('#plz-submit-button')) {
      e.preventDefault();
      if (typeof window.findProductPageContact === 'function') {
        window.findProductPageContact();
      }
    }
  });
});

// Global function for product page PLZ finder
window.findProductPageContact = function () {
  const input = document.getElementById('product-page-plz');
  const button = document.getElementById('plz-submit-button');
  const wrapper = document.getElementById('product-page-finder-wrapper');
  const result = document.getElementById('product-page-result');

  if (!input || !result || !wrapper) {
    console.error('PLZ input, wrapper oder result element nicht gefunden');
    return;
  }

  const plz = input.value;
  result.innerHTML = '';

  if (plz.length !== 5 || isNaN(parseInt(plz))) {
    result.innerHTML = '<p>Bitte geben Sie eine gültige 5-stellige Postleitzahl ein.</p>';
    return;
  }

  const contact = getContactByPlz(plz);

  // Eingabefeld und Button ausblenden
  wrapper.style.display = 'none';

  // Ansprechpartner anzeigen
  if (contact) {
    result.innerHTML = `
      <div class="mt-2">
        <p class="text-copy1 mb-2">Ihr Ansprechpartner ist <strong>${contact.name}</strong></p>
        <a href="${contact.bookingLink}" class="booking-hint inline-block" target="_blank">
          Jetzt Beratungstermin buchen →
        </a>
      </div>
    `;
  } else {
    result.innerHTML = '<p>Für diese PLZ wurde kein Ansprechpartner gefunden.</p>';
  }
};